import axios from "axios";
import { API_URL } from "@/config";
import { resetStateToDefault } from "@/lib/store/index";

const defaultState = Object.freeze({
  options: [],
});

const store = {
  namespaced: true,

  state: {
    ...defaultState,
  },

  getters: {
    hasOptions(state) {
      return state.options.length > 0;
    },
    getOptions(state) {
      return state.options;
    },
  },

  mutations: {
    setOptions(state, options) {
      state.options = options;
    },

    clearOptionsCache(state) {
      state.options = [];
    },

    resetState(state) {
      resetStateToDefault(state, defaultState);
    },
  },

  actions: {
    async getMany(_, { filters, page }) {
      const res = await axios.get(`${API_URL}/districts`, { params: { ...filters, page } });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, districtId) {
      const res = await axios.get(`${API_URL}/districts/${districtId}`);

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create({ commit }, districtData) {
      const res = await axios.post(`${API_URL}/districts`, districtData);

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      commit("clearOptionsCache");

      return res.data;
    },

    async update({ commit }, { districtId, districtData }) {
      const res = await axios.put(`${API_URL}/districts/${districtId}`, districtData);

      if (res.status !== 200 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      commit("clearOptionsCache");

      return res.data;
    },

    async remove({ commit }, districtId) {
      const res = await axios.delete(`${API_URL}/districts/${districtId}`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      commit("clearOptionsCache");

      return true;
    },

    async getOptions({ commit, state }) {
      if (state.options?.length) {
        return state.options;
      }

      const response = await axios.get(`${API_URL}/districts/options`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      commit("setOptions", response.data);

      return response.data;
    },
  },
};

export default store;
